import * as React from 'react';
import {defineMessage} from 'react-intl';
import {BuildInstructions} from '../../components/left-col';

export const buildInstructions = [
  {
    label: 'dotnet',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.dotnet.dotnet.body',
        defaultMessage: 'Install the library:',
      }),
    },
    command: 'dotnet add package Stripe.net',
    shell: true,
  },
  {
    label: 'NuGet',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.dotnet.nuget.body',
        defaultMessage: 'Install the library:',
      }),
    },
    command: 'Install-Package Stripe.net',
    shell: true,
  },
  {
    label: 'GitHub',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.dotnet.github.body',
        defaultMessage:
          'Or download the Stripe.net library source code directly ',
        description:
          'First part of a sentence that ends in docsApp.ib.aap.snippets.dotnet.github.link . Please translate them with this in mind.',
      }),
    },
    link: {
      href: 'https://github.com/stripe/stripe-dotnet',
      label: {
        message: defineMessage({
          id: 'docsApp.ib.aap.snippets.dotnet.github.link',
          defaultMessage: 'from GitHub.',
          description:
            'Second part of a sentence that begins in with docsApp.ib.aap.snippets.dotnet.github.body . Please translate them with this in mind.',
        }),
      },
    },
  },
];

export const setup = {
  heading: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.dotnet.setup.heading',
      defaultMessage: 'Install the Stripe.net library',
    }),
  },
  body: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.dotnet.setup.body',
      defaultMessage:
        'Install the package with dotnet or NuGet. Alternatively, if you’re starting from scratch and need a .csproj file, download the files using the link in the code editor.',
    }),
  },
  Component() {
    return <BuildInstructions instructions={buildInstructions} />;
  },
};

export const run = '';
